import { NgModule } from '@angular/core';
import { ClaimSubmissionComponent } from './claim-submission/claim-submission.component';
import { ClaimCustomerComponent } from './claim-customer/claim-customer.component';
import { ClaimEstimateComponent } from './claim-estimate/claim-estimate.component';
import { ClaimPicturesComponent } from './claim-pictures/claim-pictures.component';
import { ClaimRepairFacilityComponent } from './claim-repair-facility/claim-repair-facility.component';
import { ClaimSubmittedComponent } from './claim-submitted/claim-submitted.component';
import { ClaimService } from './claim.service';
import { NgxMaskModule } from 'ngx-mask';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '../../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [   
    ClaimSubmissionComponent,
    ClaimCustomerComponent,
    ClaimEstimateComponent,
    ClaimPicturesComponent,
    ClaimRepairFacilityComponent,
    ClaimSubmittedComponent  
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,    
    MatRadioModule,    
    MatChipsModule,
    MatCardModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,        
    NgxMaskModule.forRoot(),
  ],
  providers: [ { provide: 'CLAIM_SERVICE', useValue: ClaimService}]
})
export class ClaimModule {}
